module.exports = new __parcel__URL__("OKR Tracking Hover.047609df.svg").toString();